export namespace NotificationApiUri {
  const BASE_URL = '/lcm/notification/api';

  export const GET_UNREAD_NOTIFICATION_COUNT_URL = `${BASE_URL}/unread/count`;

  export const CLEAR_ALL_NOTIFICATIONS_URL = `${BASE_URL}/status/markallarchived`;

  export const READ_ALL_NOTIFICATIONS_URL = `${BASE_URL}/status/markallread`;

  export const GET_TRUNCATED_NOTIFICATIONS_URL = `${BASE_URL}/unread/truncate`;

  export const GET_ALL_NOTIFICATIONS_URL = (
    pageNumber: number,
    pageSize: number
  ) => `${BASE_URL}/${pageNumber}/${pageSize}`;

  export const UPDATE_NOTIFICATIONS_URL = (vmid: string) =>
    `${BASE_URL}/status/${vmid}`;
}
